module.exports = __webpack_public_path__ + "img/41.01ec6dc0.jpg";